import type { InvestigationQueue, InvestigationBinding } from "@shared/paddle-investigation";

export function investigationContext(search: string) {
  const p = new URLSearchParams(search.replace(/^\?/, ""));
  const queue = p.get("queue");
  const binding = p.get("binding");
  const n = Number(p.get("page") ?? 0);
  return {
    queue: (["notifications", "operations", "reconciliation"].includes(queue ?? "") ? queue : "notifications") as InvestigationQueue,
    binding: (["all", "bound", "unbound"].includes(binding ?? "") ? binding : "all") as InvestigationBinding,
    page: Number.isInteger(n) && n >= 0 && n <= 1000 ? n : 0,
    record: (p.get("record") ?? "").slice(0, 128),
  };
}

export function investigationHref(search: string, changes: Record<string, string | number | null> = {}) {
  const p = new URLSearchParams(search.replace(/^\?/, ""));
  p.set("view", "billing");
  for (const [key, value] of Object.entries(changes)) {
    if (value === null) p.delete(key);
    else p.set(key, String(value));
  }
  return `/admin?${p}`;
}

/** Accept only our own billing destination; never an arbitrary return URL. */
export function investigationReturnHref(search: string): string | null {
  const value = new URLSearchParams(search.replace(/^\?/, "")).get("billingReturn");
  if (!value || !value.startsWith("/admin?") || value.length > 2048) return null;
  const p = new URLSearchParams(value.slice("/admin?".length));
  if (p.get("view") !== "billing") return null;
  const context = investigationContext(p.toString());
  return investigationHref("", { ...context, record: context.record || null });
}

export function investigationCustomerHref(userId: string, search: string) {
  return `/admin/users/${encodeURIComponent(userId)}?${new URLSearchParams({
    billingReturn: investigationHref(search),
  })}`;
}
